module.exports = __webpack_public_path__ + "img/SM.ebc003b1.svg";